module.exports = __webpack_public_path__ + "static/knittedstripehamper-13e15598603adc4f9022957108cda339.jpeg";